const ALIASES = {
  hrt: "hormone-replacement-therapy",
};

export function normalizeSubCategory(value) {
  if (!value || !value.trim()) return "";
  const normalized = value.trim().toLowerCase();
  return ALIASES[normalized] ?? normalized;
}
